import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import mallStoresTotalVisitsQuery from '@/plugins/graphql/queries/v2/store_management/most-visited-stores.gql';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PerformanceListCountMixin from '@/helpers/vue_mixins/PerformanceListCountMixin';
import Avatar from '@/components/avatar/Index.vue';
let MostVisitedStores = class MostVisitedStores extends mixins(RouteParamsAppMixin, PerformanceListCountMixin) {
    constructor() {
        super(...arguments);
        this.section = `Most Visited Stores`;
        this.mostVisitedStorePath = {
            name: 'most-visited-store',
        };
    }
    get showPagination() {
        return this.mallStoresTotalVisits.length >= 5;
    }
};
MostVisitedStores = __decorate([
    Component({
        components: {
            Avatar,
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
        },
        apollo: {
            mallStoresTotalVisits: {
                query: mallStoresTotalVisitsQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
            },
        },
    })
], MostVisitedStores);
export default MostVisitedStores;
